import React from 'react';
import { Link } from 'react-router-dom';
import AsyncImage from '../../ui/AsyncImage/AsyncImage';

function TwoSideCard(props) {
  return (
    <div className="player-card">
      <Link to={`/jatekos-adatlap/${props.id}?squad=${props.squad}`}>
        <div className="player-card-inner">
          <figure className="player-card__front">
            <AsyncImage
              src={`${props.photo_name_card}`}
              alt={props.name}
              spacerImage="spacer-player.png"
            />
          </figure>
        </div>
      </Link>
    </div>
  );
}

export default TwoSideCard;
